exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".total-price[data-v-6a7abfd0]{font-size:13px;color:#bbb}.lp-estimate-qna[data-v-6a7abfd0]{margin-bottom:12px}.lp-estimate-qna[data-v-6a7abfd0]:last-child{margin-bottom:0}.form-item[data-v-6a7abfd0]{overflow-y:auto;height:250px;border:1px solid #ddd;padding:20px}", ""]);

// exports
